export default __webpack_public_path__ + "static/mobile-ppq-modal-images-3cfb8e0e083b1e7c691b519a164e8162.png";